export const formatTokenPrice = (n: number): string => {
  if (!Number.isFinite(n)) return '—'
  if (n >= 1) return n.toLocaleString('en-US', { maximumFractionDigits: 4 })
  if (n >= 0.0001) return n.toLocaleString('en-US', { maximumFractionDigits: 6 })
  return n.toExponential(3)
}
